import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Sparkle, LockSimple, ArrowLeft } from '@phosphor-icons/react';
import { jstDateTime } from '@/utils/jstDate';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SharedAssistantConversation() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/assistant/shared/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail || '共有リンクが無効です'));
  }, [token]);

  return (
    <div className="mx-auto max-w-3xl px-4 py-6" data-testid="assistant-shared-page">
      <Link to="/chat" className="inline-flex items-center gap-1 text-[12px] text-zinc-500 hover:text-violet-700">
        <ArrowLeft size={13} /> チャットに戻る
      </Link>
      {error ? (
        <p className="mt-6 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-[13px] text-amber-800" data-testid="assistant-shared-error">{error}</p>
      ) : !data ? (
        <p className="mt-6 text-sm text-zinc-400">読み込み中…</p>
      ) : (
        <>
          <div className="mt-4 flex items-start gap-3">
            <span className="rounded-xl bg-violet-100 p-2 text-violet-600"><Sparkle size={20} weight="duotone" /></span>
            <div className="min-w-0 flex-1">
              <h1 className="text-lg font-bold text-zinc-900 truncate" data-testid="assistant-shared-title">{data.title}</h1>
              <p className="mt-0.5 flex items-center gap-1.5 text-[11.5px] text-zinc-400">
                <LockSimple size={11} /> 読み取り専用 · 共有者: {data.owner_name} · 更新 {jstDateTime(data.updated_at)}
              </p>
            </div>
          </div>
          <div className="mt-5 space-y-3" data-testid="assistant-shared-messages">
            {data.messages.map((m, i) => (
              m.role === 'user' ? (
                <div key={i} className="flex justify-end">
                  <div className="max-w-[85%] rounded-lg rounded-br-md bg-violet-600 px-3.5 py-2 text-sm text-white whitespace-pre-wrap break-words">{m.text}</div>
                </div>
              ) : (
                <div key={i} className="flex gap-2.5">
                  <span className="mt-0.5 h-6 w-6 shrink-0 rounded-lg bg-violet-100 flex items-center justify-center text-violet-600"><Sparkle size={13} weight="fill" /></span>
                  <div className="min-w-0 max-w-[85%] rounded-lg rounded-tl-md border border-zinc-200 bg-white px-3.5 py-2 text-sm text-zinc-800 whitespace-pre-wrap break-words shadow-sm">{m.text}</div>
                </div>
              )
            ))}
          </div>
        </>
      )}
    </div>
  );
}
